import { render } from "./ProfileEmailVerify.vue?vue&type=template&id=9dafe882&lang=pug"
import script from "./ProfileEmailVerify.vue?vue&type=script&lang=js"
export * from "./ProfileEmailVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__